import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';

export function useForceBackupMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (instanceID: number) => Endpoints.v1.Backups.forceBackup(instanceID),
        onSuccess: (_data, instanceID) => {
            queryClient.invalidateQueries({ queryKey: ['api.v1.backups.list', instanceID] });
            queryClient.invalidateQueries({ queryKey: ['api.v1.instances.get', instanceID] });
            notifications.show({
                title: t('backup.startedTitle'),
                message: t('backup.startedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('backup.startFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
